import styled from '@emotion/styled';
import { ob } from '../onboardingV2.tokens';

export const ScopeNote = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 4px 0 14px;
    padding: 10px 12px;
    border-radius: ${ob.radius.md};
    background: ${ob.color.lime50};
    border: 1px solid ${ob.color.limeBorder};
    font-size: 13px;
    line-height: 1.4;
    color: ${ob.color.text};

    > i {
        margin-top: 1px;
        font-size: 16px;
        color: ${ob.color.brand};
    }
`;

export const Levels = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const LevelCard = styled.div`
    padding: 12px 14px 10px;
    border-radius: ${ob.radius.md};
    border: 1px solid ${ob.color.borderSubtle};
    background: ${ob.color.surface};
`;

export const LevelHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 28px;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 700;
    color: ${ob.color.label};
`;

export const RemoveLevel = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: ${ob.radius.sm};
    background: none;
    color: ${ob.color.muted};
    font-size: 17px;
    cursor: pointer;

    ${ob.hover} {
        &:hover {
            color: ${ob.color.error};
            background: ${ob.color.errorBg};
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }
`;

export const LevelFields = styled.div`
    display: flex;
    gap: 12px;

    > * {
        flex: 1;
        min-width: 0;
    }
`;

export const LevelMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
    margin: 6px 0 0;
    font-size: 12.5px;
    color: ${ob.color.body};

    strong {
        font-weight: 600;
        color: ${ob.color.lime700};
    }
`;

export const AddLevel = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 12px;
    padding: 10px 14px;
    border-radius: ${ob.radius.pill};
    border: 1px dashed ${ob.color.border};
    background: ${ob.color.surface};
    font-size: 14px;
    font-weight: 600;
    color: ${ob.color.brand};
    cursor: pointer;

    ${ob.hover} {
        &:hover {
            border-color: ${ob.color.borderHover};
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }
`;
